export default "__VITE_ASSET__CewuWniC__"